// Basic sound cues for the homepage showreel, synthesized with Web Audio.
// No audio file ships, so there is no audio licence to clear.

let context = null;

function audioContext() {
  if (context) return context;
  const Ctor = window.AudioContext || window.webkitAudioContext;
  if (!Ctor) return null;
  try {
    context = new Ctor();
  } catch (_) {
    context = null;
  }
  return context;
}

// A band-passed noise burst that sweeps upward: a soft whoosh on each cut.
function whoosh(ctx) {
  const t = ctx.currentTime;
  const duration = 0.55;
  const buffer = ctx.createBuffer(1, Math.floor(ctx.sampleRate * duration), ctx.sampleRate);
  const samples = buffer.getChannelData(0);
  for (let i = 0; i < samples.length; i += 1) samples[i] = Math.random() * 2 - 1;

  const source = ctx.createBufferSource();
  source.buffer = buffer;

  const filter = ctx.createBiquadFilter();
  filter.type = "bandpass";
  filter.Q.value = 0.9;
  filter.frequency.setValueAtTime(350, t);
  filter.frequency.exponentialRampToValueAtTime(2600, t + duration);

  const gain = ctx.createGain();
  gain.gain.setValueAtTime(0.0001, t);
  gain.gain.exponentialRampToValueAtTime(0.22, t + 0.12);
  gain.gain.exponentialRampToValueAtTime(0.0001, t + duration);

  source.connect(filter);
  filter.connect(gain);
  gain.connect(ctx.destination);
  source.start(t);
  source.stop(t + duration);
}

// Two soft sine tones a fifth apart: the sound that confirms sound is on.
function chime(ctx) {
  const t = ctx.currentTime;
  [[880, 0], [1320, 0.09]].forEach(([frequency, delay]) => {
    const start = t + delay;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(frequency, start);
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(0.16, start + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.7);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(start);
    osc.stop(start + 0.75);
  });
}

const CUES = { whoosh, chime };

// Plays a named cue. Returns false when the cue name is unknown or the browser
// has no Web Audio. Callers only ask once the viewer has tapped the page.
export function playCue(kind) {
  const play = Object.prototype.hasOwnProperty.call(CUES, kind) ? CUES[kind] : null;
  if (!play) return false;
  const ctx = audioContext();
  if (!ctx) return false;
  if (ctx.state === "suspended" && typeof ctx.resume === "function") {
    ctx.resume().then(() => play(ctx)).catch(() => {});
    return true;
  }
  play(ctx);
  return true;
}
